import { breakpoints, CleanButton, linkStyle } from '@gassan-ui'
import { motion } from 'framer-motion'
import { rem } from 'polished'
import styled from 'styled-components'

export const Col = styled.div`
  background: #fff;
  position: relative;
  height: calc(env(safe-area-inset-bottom) + 3rem);

  @media screen and (min-width: ${breakpoints.small}) {
    height: calc(env(safe-area-inset-bottom) + ${rem(80)});
  }
`

export const Indicator = styled.div`
  position: relative;

  font-family: ${p => p.theme.fonts.body};
  font-size: ${rem(14)};
  color: #fff;

  font-weight: 600;
  display: flex;
  text-align: center;
  justify-content: center;
  letter-spacing: 0;
  align-items: center;
  margin-left: 0.5rem;
  z-index: 2;
  line-height: 1;
  min-width: ${rem(20)};
  height: ${rem(20)};
  &::before {
    z-index: -1;
    position: absolute;
    content: '';
    width: ${rem(20)};
    height: ${rem(20)};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: ${rem(10)};
  }
`

export const Button = styled(CleanButton)<{ isActive: boolean }>`
  ${linkStyle};
  transition: color 0.25s ease-in-out;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  top: 0;
  width: 100%;
  color: ${p => (p.isActive ? p.theme.colors.shades[800] : p.theme.colors.shades[500])};
  @media screen and (min-width: ${breakpoints.small}) {
    height: ${rem(80)};
  }

  ${Indicator}::before {
    background: ${p => (p.isActive ? p.theme.colors.shades[800] : p.theme.colors.shades[500])};
  }
`

export const Grid = styled(motion.div)`
  background: #fff;
  z-index: ${p => p.theme.zIndices.mobileFilters.buttons};
  border-top: 1px solid ${p => p.theme.colors.shades[200]};
  position: fixed;
  display: grid;
  bottom: 0;
  left: 0;
  width: 100%;
  grid-template-columns: 1fr 1px 1fr;
`
